<template>
  <b-link class="btn--pricelist"
          @click="onclick">
    {{ $t('pages.checkins_detail.label_price_list') }}
    <Icon name="coin" width="20"/>
  </b-link>
</template>
<script>
export default {
  name: "PriceListButton",
  emits: ['click'],
  methods: {
    onclick() {
      this.$emit('click');
    }
  }
}
</script>


<style scoped>

</style>